/*
 FileAssignment component
 url match: / or /login
 Displays email id and password field
 with FileAssignment button
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { settingsStyles } from '../../Styles/userStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Loader from 'react-loader-spinner'
import InputAdornment from '@material-ui/core/InputAdornment';
import { ReactSVG } from 'react-svg';
import Images from '../../Theme/Images';
import FormHelperText from '@material-ui/core/FormHelperText';

@inject('adminStore', 'commonStore')
@observer
class AdminChangePassword extends React.Component {
    state = {
        newPassword: '',
        validationErrors: {},
        user: {},
        showPassword: false
    }

    handleChange = (field, event) => {
        event.stopPropagation();
        this.setState({
            [field]: event.target.value
        })
    }

    validateFields() {
        const { newPassword, validationErrors } = this.state;
        let valid = true;
        if (!newPassword || newPassword.length < 6 || newPassword.length > 25) {
            validationErrors['newPassword'] = "Please enter a valid password with min. 6 and max. 25 characters";
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors['newPassword']
        if (valid) {
            delete validationErrors['newPassword'];
            this.setState({ validationErrors });
        }
        return valid;
    }

    cancel = () => {
        this.props.adminStore.openChangePasswordDialog(false);
        this.resetState()
    }

    changePassword = () => {
        const { newPassword } = this.state
        if (!newPassword) {
            this.props.commonStore.handleOpenSnackBar("Please enter the new password before proceeding", "info")
            return;
        }
        if (this.validateFields()) {
            this.props.adminStore.changePassword(this.props.user._id, newPassword)
                .then((res) => {
                    this.resetState()
                });
        }
    }

    resetState = () => {
        this.setState({ newPassword: '', validationErrors: {} })
    }



    render() {
        const { classes, theme, user } = this.props;
        const { changePasswordDialog, inProgress } = this.props.adminStore;
        const { newPassword, validationErrors, showPassword } = this.state
        return (
            <Dialog BackdropProps={{
                classes: {
                    root: classes.backdrop
                }
            }} disableBackdropClick={true} disableEscapeKeyDown={true} classes={{ paper: classes.dialog }} open={changePasswordDialog} onClose={this.closeDialog} aria-labelledby="form-dialog-title">
                <DialogTitle style={{ color: 'white' }}>
                    <div style={{ textAlign: 'center' }}>
                        <ReactSVG src={Images.lock} />
                        <div>Change Password for {user.userFullName}</div>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <TextField color="primary" style={{ paddingTop: 0, marginTop: 0 }} id="new"
                        label='New Password'
                        margin="normal"
                        variant="filled"
                        InputProps={{
                            disableUnderline: true,
                            endAdornment: <InputAdornment position="end" >
                                {!showPassword ? <ReactSVG src={Images.visibilityIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword: true })} /> :
                                    <ReactSVG src={Images.visibilityOffIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword: false })} />}
                            </InputAdornment>
                        }}
                        fullWidth
                        value={newPassword}
                        type={showPassword ? 'text' : 'password'}
                        onChange={(event) => this.handleChange('newPassword', event)}
                    />
                    {validationErrors.newPassword && <FormHelperText style={{ display: 'flex', color: 'red' }} id="pwd-error"><ReactSVG
                        beforeInjection={svg => {
                            svg.classList.add(classes.svg)
                        }}
                        src={Images.error} />&nbsp;{validationErrors.newPassword}</FormHelperText>}
                    <div className={classes.saveContainer} style={{ justifyContent: 'space-between' }}>
                        <Button variant="contained" onClick={this.cancel} className={classes.passwordButtons} type="submit" > Cancel  </Button>
                        {
                            inProgress ?
                                <Button variant="contained" className={classes.passwordButtons} style={{ backgroundColor: theme.palette.blue }}><Loader height={30} width={30} color={this.props.theme.palette.white} /></Button> :
                                <Button variant="contained" onClick={this.changePassword} className={classes.passwordButtons} style={{ backgroundColor: theme.palette.blue }} type="submit" > Change Password  </Button>

                        }
                    </div>
                </DialogContent>

            </Dialog>

        )
    }
}
export default withStyles(settingsStyles, { withTheme: true })(withRouter(AdminChangePassword));
